/**
 * @function createTag
 * @description create an HTML element with an attribute and styles
 * @param {string} tag HTML tag of the element
 * @param {string} attr attribute to add to the HTML tag
 * @param {string} value the value of the attribute
 * @param {string} style the style string to apply to the element
 * @returns {HTMLElement}
 */
export default function createTag(tag, attr, value, style) {
    /* simplify the creation of tags with data-attributes */
    const element = document.createElement(tag);
    if (attr) element.setAttribute(attr, value);
    if (style) element.setAttribute('class', style);
    return element;
}
